module.exports = __webpack_public_path__ + "static/img/ziyuan_03.5ae9c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ziyuan_03.png
// module id = sE2C
// module chunks = 0